import comp from "./StudentBlock";
export default comp;
